export default __webpack_public_path__ + "img/kebab-horizontal.36c5d536.svg";